import styled, { keyframes } from 'styled-components';


const fetchingMotion = keyframes`
	100% {
		background-position: 200px 0;
	}
`;

const Root = styled.div`
	display: 'inline-block';
`;

const Placeholder = styled.div`
	display: inline-block;
	width: 100%;
	max-width: 200px;
	height: 23px;
	background: linear-gradient(90deg, #EEEEEE 0%, #F5F5F5 100%);
	background-position: 0 0;
	animation: ${fetchingMotion} .8s infinite alternate;
	animation-timing-function: ease-in-out;
`;

export {
	Root,
	Placeholder,
};
